var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullHeight mx-0"},[_c('registration-form',{on:{"submit":_vm.register}}),(_vm.renderRegistrationConfirmation)?_c('registration-confirmation'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }